<template>
  <svg :fill="fillColor"
       class="material-design-icon__svg"
       viewBox="0 0 24 24">
    <path
        d="M4,3H20A2,2 0 0,1 22,5V20A2,2 0 0,1 20,22H4A2,2 0 0,1 2,20V5A2,2 0 0,1 4,3M4,7V10H8V7H4M10,7V10H14V7H10M20,10V7H16V10H20M4,12V15H8V12H4M4,20H8V17H4V20M10,12V15H14V12H10M10,20H14V17H10V20M20,20V17H16V20H20M20,12H16V15H20V12Z"/>
  </svg>
</template>

<script>
export default {
  name: "TableLargeIcon",
  props: {
    fillColor: {
      type: String,
      default: "currentColor"
    },
  }
}
</script>